const LABEL_IDENTIFICADOR_ESPECIAL = {
  ARMA_DE_FOGO: {
    label: 'NIAF - Número de identificação de Arma de Fogo',
    sigla: 'NIAF',
  },
  CONTEUDO_BALISTICO_COM_ARMA: {
    label: 'NIAF - Número de identificação de Arma de Fogo',
    sigla: 'NIAF',
  },
  CADAVER_GENERICO: { label: 'NIC - Número de Identificação Cadavérica', sigla: 'NIC' },
  CADAVER_ESPECIFICO: { label: 'NIC - Número de Identificação Cadavérica', sigla: 'NIC' },
}

const PERMISSOES = {
  AUTENTICAR_USUARIO_LOCAL: 'AUTENTICAR_USUARIO_LOCAL',
  REDEFINIR_TOKEN: 'REDEFINIR_TOKEN',
  REDEFINIR_SENHA: 'REDEFINIR_SENHA',
  SOLICITAR_REDEFINIR_SENHA: 'SOLICITAR_REDEFINIR_SENHA',
  CADASTRAR_CADAVER: 'CADASTRAR_CADAVER',
  RECONHECER_CADAVER: 'RECONHECER_CADAVER',
  ENTREGAR_CADAVER: 'ENTREGAR_CADAVER',
  LISTAR_CADAVER: 'LISTAR_CADAVER',
  LIBERAR_CADAVER: 'LIBERAR_CADAVER',
  LISTAR_CASO: 'LISTAR_CASO',
  CADASTRAR_CASO: 'CADASTRAR_CASO',
  CADASTRAR_ENDERECO: 'CADASTRAR_ENDERECO',
  LISTAR_ENDERECO: 'LISTAR_ENDERECO',
  LISTAR_EXAME_SOLICITADO: 'LISTAR_EXAME_SOLICITADO',
  ASSUMIR_EXAME_SOLICITADO: 'ASSUMIR_EXAME_SOLICITADO',
  ATRIBUIR_EXAMINADORES_EXAME_SOLICITADO: 'ATRIBUIR_EXAMINADORES_EXAME_SOLICITADO',
  REALIZAR_EXAME: 'REALIZAR_EXAME',
  LISTAR_EXAME_REALIZADO: 'LISTAR_EXAME_REALIZADO',
  DOWNLOAD_DOCUMENTO_EXAME_REALIZADO: 'DOWNLOAD_DOCUMENTO_EXAME_REALIZADO',
  LISTAR_SETORES: 'LISTAR_SETORES',
  CADASTRAR_PERICIANDO: 'CADASTRAR_PERICIANDO',
  LISTAR_PERICIANDO: 'LISTAR_PERICIANDO',
  CONSULTAR_REGISTRO_CIVIL: 'CONSULTAR_REGISTRO_CIVIL',
  PESQUISAR_OBJETOS: 'PESQUISAR_OBJETOS',
  LISTAR_SOLICITACOES_EXAME: 'LISTAR_SOLICITACOES_EXAME',
  CADASTRAR_SOLICITACAO_EXAME: 'CADASTRAR_SOLICITACAO_EXAME',
  LISTAR_USUARIOS: 'LISTAR_USUARIOS',
  ENCAMINHAR_VESTIGIO: 'ENCAMINHAR_VESTIGIO',
  RETIRAR_VESTIGIO: 'RETIRAR_VESTIGIO',
  GUARDAR_VESTIGIO: 'GUARDAR_VESTIGIO',
  DESCARTAR_VESTIGIO: 'DESCARTAR_VESTIGIO',
  ACEITAR_VESTIGIO: 'ACEITAR_VESTIGIO',
  LISTAR_VESTIGIOS: 'LISTAR_VESTIGIOS',
  CADASTRAR_VESTIGIO: 'CADASTRAR_VESTIGIO',
  CADASTRAR_VESTIGIO_POR_EXTRACAO: 'CADASTRAR_VESTIGIO_POR_EXTRACAO',
  SOLICITAR_EXAME: 'SOLICITAR_EXAME',
  SOLICITAR_PASSAGEM_CUSTODIA: 'SOLICITAR_PASSAGEM_CUSTODIA',
  ACEITAR_PASSAGEM_CUSTODIA: 'ACEITAR_PASSAGEM_CUSTODIA',
  ADMINISTRAR_SISTEMA: 'ADMINISTRAR_SISTEMA',
  LISTAR_VEICULOS: 'LISTAR_VEICULOS',
  CADASTRAR_VEICULO: 'CADASTRAR_VEICULO',
  VINCULAR_VESTIGIO_EXAME_SOLICITADO: 'VINCULAR_VESTIGIO_EXAME_SOLICITADO',
  ENTREGAR_VESTIGIO: 'ENTREGAR_VESTIGIO',
  CADASTRAR_INFORMACAO_VESTIGIO: 'CADASTRAR_INFORMACAO_VESTIGIO',
  ATRIBUIR_EXAMINADOR_SUPERIOR: 'ATRIBUIR_EXAMINADOR_SUPERIOR',
  PUBLICAR_EXAME_REALIZADO: 'PUBLICAR_EXAME_REALIZADO',
  CONSUMIR_VESTIGIO: 'CONSUMIR_VESTIGIO',
  PUBLICAR_EXAME_REALIZADO_OUTRO_SETOR: 'PUBLICAR_EXAME_REALIZADO_OUTRO_SETOR',
  GERENCIAR_VAGAS: 'GERENCIAR_VAGAS',
  GERENCIAR_REPORT: 'GERENCIAR_REPORT',
  REPORTAR: 'REPORTAR',
  CADASTRAR_ANUNCIO: 'CADASTRAR_ANUNCIO',
  RETORNAR_VESTIGIO: 'RETORNAR_VESTIGIO',
  RETORNAR_VESTIGIO_ADMINISTRADOR: 'RETORNAR_VESTIGIO_ADMINISTRADOR',
  QUALIFICAR_PERICIANDO: 'QUALIFICAR_PERICIANDO',
  GERENCIAR_REQUISICOES: 'GERENCIAR_REQUISICOES',
  GERENCIAR_CUSTODIA: 'GERENCIAR_CUSTODIA',
  CADASTRAR_USUARIO: 'CADASTRAR_USUARIO',
}

const TIPOS_EXAMES = {
  EFICIENCIA_BALISTICA: 'EFICIENCIA_BALISTICA',
  CONFRONTO_BALISTICO: 'CONFRONTO_BALISTICO',
  IDENTIFICACAO_BALISTICA: 'IDENTIFICACAO_BALISTICA',
  NECROSCOPICO: 'NECROSCOPICO',
  PESQUISA_SANGUE_HUMANO: 'PESQUISA_SANGUE_HUMANO',
  CONSTATACAO: 'CONSTATACAO',
  QUIMICO_TOXICOLOGICO: 'QUIMICO_TOXICOLOGICO',
  DOSAGEM_ALCOOLICA: 'DOSAGEM_ALCOOLICA',
  IDENTIFICACAO_VEICULAR: 'IDENTIFICACAO_VEICULAR',
  VEICULAR: 'VEICULAR',
  TOXICOLOGICO_POST_MORTEM_DAF: 'TOXICOLOGICO_POST_MORTEM_DAF',
  TOXICOLOGICO_POST_MORTEM_PEST: 'TOXICOLOGICO_POST_MORTEM_PEST',
  TOXICOLOGICO_IN_VIVO: 'TOXICOLOGICO_IN_VIVO',
  CONJUNCAO_CARNAL: 'CONJUNCAO_CARNAL',
  ATO_LIBIDINOSO: 'ATO_LIBIDINOSO',
  PSICOLOGICA: 'PSICOLOGICA',
  LESAO_CORPORAL: 'LESAO_CORPORAL',
  ACHADO_CADAVER: 'ACHADO_CADAVER',
  IMOVEL: 'IMOVEL',
  TRAFEGO: 'TRAFEGO',
  ESPERMATOSOIDE_PSA: 'ESPERMATOSOIDE_PSA',
  RESIDUOGRAFICO: 'RESIDUOGRAFICO',
  DNA: 'DNA',
  QUIMICO_VOLATEIS: 'QUIMICO_VOLATEIS',
  QUIMICO_ANABOLIZANTES: 'QUIMICO_ANABOLIZANTES',
  QUIMICO_OUTRAS_SUBSTANCIAS: 'QUIMICO_OUTRAS_SUBSTANCIAS',
  DOCUMENTOSCOPICO: 'DOCUMENTOSCOPICO',
  OBJETO: 'OBJETO',
  COMPLEMENTAR: 'COMPLEMENTAR',
  PAPILOSCOPICO: 'PAPILOSCOPICO',
  CONFRONTO_PAPILOSCOPICO: 'CONFRONTO_PAPILOSCOPICO',
  GRAFOTÉCNICO: 'GRAFOTÉCNICO',
  ANTROPOLOGICO: 'ANTROPOLOGICO',
  AMBIENTAL: 'AMBIENTAL',
  MERCEOLOGICO: 'MERCEOLOGICO',
  INFORMATICA: 'INFORMATICA',
  INCENDIO: 'INCENDIO',
  AUDIO_VISUAL: 'AUDIO_VISUAL',
  CONTABIL: 'CONTABIL',
  ENGENHARIA_LEGAL: 'ENGENHARIA_LEGAL',
  CORPO_ESTRANHO: 'CORPO_ESTRANHO',
  GRAVIDEZ: 'GRAVIDEZ',
  CONFIRMACAO_IDENTIDADE: 'CONFIRMACAO_IDENTIDADE',
  IDENTIFICACAO_CRIMINAL: 'IDENTIFICACAO_CRIMINAL',
  CESSACAO_PERICULOSIDADE: 'CESSACAO_PERICULOSIDADE',
  //SUPERVENIENCIA_DOENCA_MENTAL: 'SUPERVENIENCIA_DOENCA_MENTAL', //verificar se este é o nome correto
}

const LABEL_EXAMES_REALIZADOS = {
  EFICIENCIA_BALISTICA: 'Exame de Eficiência',
  CONFRONTO_BALISTICO: 'Exame de Confronto Balístico',
  NECROSCOPICO: 'Exame Necroscópico',
  PESQUISA_SANGUE_HUMANO: 'Exame de Pesquisa de Sangue Humano',
  CONSTATACAO: 'Exame de Constatação',
  QUIMICO_TOXICOLOGICO: 'Exame Químico-Toxicológico',
  DOSAGEM_ALCOOLICA: 'Exame de Dosagem Alcoólica',
  IDENTIFICACAO_VEICULAR: 'Exame Pericial de Identificação Veicular',
  VEICULAR: 'Exame Pericial em Veículo',
  TOXICOLOGICO_POST_MORTEM_DAF: 'Exame Toxicológico POST MORTEM Drogas de Abuso e Fármacos',
  TOXICOLOGICO_POST_MORTEM_PEST: 'Exame Toxicológico POST MORTEM Pesticidas',
  TOXICOLOGICO_IN_VIVO: 'Exame Toxicológico IN VIVO',
  CONJUNCAO_CARNAL: 'Exame de Conjunção Carna',
  ATO_LIBIDINOSO: 'Exame de Ato Libidinoso',
  PSICOLOGICA: 'Exame de Perícia Psicológica',
  LESAO_CORPORAL: 'Exame de Lesão Corporal',
  ACHADO_CADAVER: 'Exame Achado de Cadáver',
  IMOVEL: 'Exame Pericial em Imóvel',
  TRAFEGO: 'Exame Pericial de Ocorrência de Tráfego',
  ESPERMATOSOIDE_PSA: 'Exame Pesquisa de Espermatozoide e PSA',
  RESIDUOGRAFICO: 'Exame Pericial Residuográfico de Chumbo',
  DNA: 'Exame de DNA',
  QUIMICO_VOLATEIS: 'Exame Químico Substâncias Voláteis',
  QUIMICO_ANABOLIZANTES: 'Exame Químico Substâncias Anabolizantes',
  QUIMICO_OUTRAS_SUBSTANCIAS: 'Exame Químico - Outras Substâncias',
  DOCUMENTOSCOPICO: 'Exame Pericial Documentoscópico',
  OBJETO: 'Exame Pericial em Objeto',
  COMPLEMENTAR: 'Exame Complementar',
  PAPILOSCOPICO: 'Exame Pericial Papiloscópico',
  CONFRONTO_PAPILOSCOPICO: 'Exame Pericial de Confronto Papiloscópico',
  GRAFOTÉCNICO: 'Exame Pericial Grafotécnico',
  ANTROPOLOGICO: 'Exame Antropológico',
  AMBIENTAL: 'Exame Pericial Ambiental',
  MERCEOLOGICO: 'Exame Pericial Merceológico',
  INFORMATICA: 'Exame Pericial de Equipamento de Informática',
  INCENDIO: 'Exame Pericial em Local de Incêndio',
  AUDIO_VISUAL: 'Exame Pericial em Audiovisual',
  CONTABIL: 'Exame Pericial Contábil',
  ENGENHARIA_LEGAL: 'Exame Pericial de Engenharia Legal',
  CORPO_ESTRANHO: 'Exame de Corpo Estranho',
  GRAVIDEZ: 'Exame Teste de Gravidez (Pesquisa de HCG)',
  IDENTIFICACAO_BALISTICA: 'Exame de Identificação Balística',
}

const REGIOES_CORPO = [
  'CERVICAL',
  'OCCIPITAL',
  'AURICULAR_ESQUERDA',
  'AURICULAR_DIREITA',
  'TEMPORAL_ESQUERDA',
  'TEMPORAL_DIREITA',
  'PARIETAL_ESQUERDA',
  'PARIETAL_DIREITA',
  'QUINTO_QUIRODACTILO_ESQUERDO',
  'QUARTO_QUIRODACTILO_ESQUERDO',
  'TERCEIRO_QUIRODACTILO_ESQUERDO',
  'SEGUNDO_QUIRODACTILO_ESQUERDO',
  'PRIMEIRO_QUIRODACTILO_ESQUERDO',
  'DORSAL_MAO_ESQUERDA',
  'POSTERIOR_PUNHO_ESQUERDO',
  'POSTERIOR_TERCO_INFERIOR_ANTEBRACO_ESQUERDO',
  'POSTERIOR_TERCO_MEDIO_ANTEBRACO_ESQUERDO',
  'POSTERIOR_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO',
  'COTOVELO_ESQUERDO',
  'POSTERIOR_TERCO_INFERIOR_BRACO_ESQUERDO',
  'POSTERIOR_TERCO_MEDIO_BRACO_ESQUERDO',
  'POSTERIOR_TERCO_SUPERIOR_BRACO_ESQUERDO',
  'POSTERIOR_DELTOIDIANA_ESQUERDA',
  'QUINTO_QUIRODACTILO_DIREITO',
  'QUARTO_QUIRODACTILO_DIREITO',
  'TERCEIRO_QUIRODACTILO_DIREITO',
  'SEGUNDO_QUIRODACTILO_DIREITO',
  'PRIMEIRO_QUIRODACTILO_DIREITO',
  'DORSAL_MAO_DIREITA',
  'POSTERIOR_PUNHO_DIREITO',
  'POSTERIOR_TERCO_INFERIOR_ANTEBRACO_DIREITO',
  'POSTERIOR_TERCO_MEDIO_ANTEBRACO_DIREITO',
  'POSTERIOR_TERCO_SUPERIOR_ANTEBRACO_DIREITO',
  'COTOVELO_DIREITO',
  'POSTERIOR_TERCO_INFERIOR_BRACO_DIREITO',
  'POSTERIOR_TERCO_MEDIO_BRACO_DIREITO',
  'POSTERIOR_TERCO_SUPERIOR_BRACO_DIREITO',
  'POSTERIOR_DELTOIDIANA_DIREITA',
  'ILIACA_DIREITA',
  'ILIACA_ESQUERDA',
  'LOMBAR_DIREITA',
  'LOMBAR_ESQUERDA',
  'DORSAL_DIREITA',
  'DORSAL_ESQUERDA',
  'ESCAPULAR_DIREITA',
  'ESCAPULAR_ESQUERDA',
  'SACROCOCCIGIANA',
  'ESPONDILIANA',
  'SUPRA_ESCAPULAR_ESQUERDA',
  'SUPRA_ESCAPULAR_DIREITA',
  'BORDA_EXTERNA_PE_ESQUERDO',
  'CALCANEANA_ESQUERDA',
  'MALEOLAR_EXTERNA_ESQUERDA',
  'POSTERIOR_TERCO_INFERIOR_PERNA_ESQUERDA',
  'POSTERIOR_TERCO_MEDIO_PERNA_ESQUERDA',
  'POSTERIOR_TERCO_SUPERIOR_PERNA_ESQUERDA',
  'POPLITEA_ESQUERDA',
  'POSTERIOR_TERCO_INFERIOR_COXA_ESQUERDA',
  'POSTERIOR_TERCO_MEDIO_COXA_ESQUERDA',
  'POSTERIOR_TERCO_SUPERIOR_COXA_ESQUERDA',
  'GLUTEA_ESQUERDA',
  'BORDA_EXTERNA_PE_DIREITO',
  'CALCANEANA_DIREITA',
  'MALEOLAR_EXTERNA_DIREITA',
  'POSTERIOR_TERCO_INFERIOR_PERNA_DIREITA',
  'POSTERIOR_TERCO_MEDIO_PERNA_DIREITA',
  'POSTERIOR_TERCO_SUPERIOR_PERNA_DIREITA',
  'POPLITEA_DIREITA',
  'POSTERIOR_TERCO_INFERIOR_COXA_DIREITA',
  'POSTERIOR_TERCO_MEDIO_COXA_DIREITA',
  'POSTERIOR_TERCO_SUPERIOR_COXA_DIREITA',
  'GLUETEA_DIREITA',
  'INFRA_HIOIDIANA',
  'SUPRA_HIOIDIANA',
  'CAROTIDIANA_ESQUERDA',
  'CAROTIDIANA_DIREITA',
  'MENTONIANA',
  'BUCINADORA_ESQUERDA',
  'BUCINADORA_DIREITA',
  'MASSETERIANA_ESQUERDA',
  'MASSETERIANA_DIREITA',
  'LABIAL',
  'MALAR_ESQUERDA',
  'MALAR_DIREITA',
  'NASAL',
  'ZIGOMATICA_ESQUERDA',
  'ZIGOMATICA_DIREITA',
  'ORBITAL_DIREITA',
  'ORBITAL_ESQUERDA',
  'FRONTAL',
  'HIPOTENAR_DIREITA',
  'CONCAVO_MAO_DIREITA',
  'TENAR_DIREITA',
  'INTERNA_PUNHO_DIREITO',
  'ANTERIOR_PUNHO_DIREITO',
  'INTERNA_TERCO_INFERIOR_ANTEBRACO_DIREITO',
  'ANTERIOR_TERCO_INFERIOR_ANTEBRACO_DIREITO',
  'INTERNA_TERCO_MEDIO_ANTEBRACO_DIREITO',
  'ANTERIOR_TERCO_MEDIO_ANTEBRACO_DIREITO',
  'INTERNA_TERCO_SUPERIOR_ANTEBRACO_DIREITO',
  'ANTERIOR_TERCO_SUPERIOR_ANTEBRACO_DIREITO',
  'INTERNA_PREGA_COTOVELO_DIREITO',
  'PREGA_COTOVELO_DIREITO',
  'INTERNA_TERCO_INFERIOR_BRACO_DIREITO',
  'ANTERIOR_TERCO_INFERIOR_BRACO_DIREITO',
  'INTERNA_TERCO_MEDIO_BRACO_DIREITO',
  'ANTERIOR_TERCO_MEDIO_BRACO_DIREITO',
  'INTERNA_TERCO_SUPERIOR_BRACO_DIREITO',
  'ANTERIOR_TERCO_SUPERIOR_BRACO_DIREITO',
  'DELTOIDIANA_DIREITA',
  'TENAR_ESQUERDA',
  'CONCAVO_MAO_ESQUERDA',
  'HIPOTENAR_ESQUERDA',
  'INTERNA_PUNHO_ESQUERDO',
  'ANTERIOR_PUNHO_ESQUERDO',
  'INTERNA_TERCO_INFERIOR_BRACO_ESQUERDO',
  'INTERNA_TERCO_INFERIOR_ANTEBRACO_ESQUERDO',
  'ANTERIOR_TERCO_INFERIOR_ANTEBRACO_ESQUERDO',
  'INTERNA_TERCO_MEDIO_ANTEBRACO_ESQUERDO',
  'ANTERIOR_TERCO_MEDIO_ANTEBRACO_ESQUERDO',
  'INTERNA_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO',
  'ANTERIOR_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO',
  'INTERNA_PREGA_COTOVELO_ESQUERDO',
  'ANTERIOR_PREGA_COTOVELO_ESQUERDO',
  'ANTERIOR_TERCO_INFERIOR_BRACO_ESQUERDO',
  'INTERNA_TERCO_MEDIO_BRACO_ESQUERDO',
  'ANTERIOR_TERCO_MEDIO_BRACO_ESQUERDO',
  'INTERNA_TERCO_SUPERIOR_BRACO_ESQUERDO',
  'ANTERIOR_TERCO_SUPERIOR_BRACO_ESQUERDO',
  'DELTOIDIANA_ESQUERDA',
  'ESCROTAL',
  'PENIANA',
  'PUBIANA',
  'INGUINAL_ESQUERDA',
  'INGUINAL_DIREITA',
  'FOSSA_ILIACA_ESQUERDA',
  'FOSSA_ILIACA_DIREITA',
  'HIPOGASTRICA',
  'UMBILICAL',
  'FLANCO_ESQUERDO',
  'MESOGASTRICA',
  'FLANCO_DIREITO',
  'HIPOCONDRIO_ESQUERDO',
  'EPIGASTRICA',
  'HIPOCONDRIO_DIREITO',
  'MAMILAR_ESQUERDA',
  'MAMILAR_DIREITA',
  'MAMARIA_ESQUERDA',
  'MAMARIA_DIREITA',
  'TORACICA_ESQUERDA',
  'TORACICA_DIREITA',
  'ESTERNAL',
  'INFRACLAVICULAR_ESQUERDA',
  'INFRACLAVICULAR_DIREITA',
  'CLAVICULAR_ESQUERDA',
  'CLAVICULAR_DIREITA',
  'SUPRACLAVICULAR_DIREITA',
  'SUPRACLAVICULAR_ESQUERDA',
  'QUINTO_PEDODACTILO_DIREITO',
  'QUARTO_PEDODACTILO_DIREITO',
  'TERCEIRO_PEDODACTILO_DIREITO',
  'SEGUNDO_PEDODACTILO_DIREITO',
  'PRIMEIRO_PEDODACTILO_DIREITO',
  'DORSAL_PE_DIREITO',
  'MALEOLAR_INTERNA_DIREITA',
  'INTERNA_TERCO_INFERIOR_PERNA_DIREITA',
  'ANTERIOR_TERCO_INFERIOR_PERNA_DIREITA',
  'INTERNA_TERCO_MEDIO_PERNA_DIREITA',
  'ANTERIOR_TERCO_MEDIO_PERNA_DIREITA',
  'INTERNA_TERCO_SUPERIOR_PERNA_DIREITA',
  'ANTERIOR_TERCO_SUPERIOR_PERNA_DIREITA',
  'ROTULIANA_DIREITA',
  'INTERNA_JOELHO_DIREITO',
  'ANTERIOR_JOELHO_DIREITO',
  'INTERNA_TERCO_INFERIOR_COXA_DIREITA',
  'ANTERIOR_TERCO_INFERIOR_COXA_DIREITA',
  'INTERNA_TERCO_MEDIO_COXA_DIREITA',
  'ANTERIOR_TERCO_MEDIO_COXA_DIREITA',
  'INTERNA_TERCO_SUPERIOR_COXA_DIREITA',
  'ANTERIOR_TERCO_SUPERIOR_COXA_DIREITA',
  'CRURAL_DIREITA',
  'QUINTO_PEDODACTILO_ESQUERDO',
  'QUARTO_PEDODACTILO_ESQUERDO',
  'TERCEIRO_PEDODACTILO_ESQUERDO',
  'SEGUNDO_PEDODACTILO_ESQUERDO',
  'PRIMEIRO_PEDODACTILO_ESQUERDO',
  'DORSAL_PE_ESQUERDO',
  'MALEOLAR_INTERNA_ESQUERDA',
  'INTERNA_TERCO_INFERIOR_PERNA_ESQUERDA',
  'ANTERIOR_TERCO_INFERIOR_PERNA_ESQUERDA',
  'INTERNA_TERCO_MEDIO_PERNA_ESQUERDA',
  'ANTERIOR_TERCO_MEDIO_PERNA_ESQUERDA',
  'INTERNA_TERCO_SUPERIOR_PERNA_ESQUERDA',
  'ANTERIOR_TERCO_SUPERIOR_PERNA_ESQUERDA',
  'ROTULIANA_ESQUERDA',
  'INTERNA_JOELHO_ESQUERDO',
  'ANTERIOR_JOELHO_ESQUERDO',
  'INTERNA_TERCO_INFERIOR_COXA_ESQUERDA',
  'ANTERIOR_TERCO_INFERIOR_COXA_ESQUERDA',
  'INTERNA_TERCO_MEDIO_COXA_ESQUERDA',
  'ANTERIOR_TERCO_MEDIO_COXA_ESQUERDA',
  'INTERNA_TERCO_SUPERIOR_COXA_ESQUERDA',
  'ANTERIOR_TERCO_SUPERIOR_COXA_ESQUERDA',
  'CRURAL_ESQUERDA',
  'LATERAL_PESCOCO_ESQUERDA',
  'PALMAR_MAO_ESQUERDA',
  'EXTERNA_PUNHO_ESQUERDO',
  'EXTERNA_TERCO_INFERIOR_ANTEBRACO_ESQUERDO',
  'EXTERNA_TERCO_MEDIO_ANTEBRACO_ESQUERDO',
  'EXTERNA_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO',
  'EXTERNA_COTOVELO_ESQUERDO',
  'EXTERNA_TERCO_INFERIOR_BRACO_ESQUERDO',
  'EXTERNA_TERCO_MEDIO_BRACO_ESQUERDO',
  'EXTERNA_TERCO_SUPERIOR_BRACO_ESQUERDO',
  'ESCAPULO_UMERAL_ESQUERDA',
  'LATERAL_EXTERNA_PE_ESQUERDO',
  'MALEOLAR_ESQUERDA',
  'EXTERNA_TERCO_INFERIOR_PERNA_ESQUERDA',
  'EXTERNA_TERCO_SUPERIOR_PERNA_ESQUERDA',
  'EXTERNA_TERCO_MEDIO_PERNA_ESQUERDA',
  'EXTERNA_JOELHO_ESQUERDO',
  'EXTERNA_TERCO_INFERIOR_COXA_ESQUERDA',
  'EXTERNA_TERCO_MEDIO_COXA_ESQUERDA',
  'EXTERNA_TERCO_SUPERIOR_COXA_ESQUERDA',
  'QUADRIL_ESQUERDA',
  'LATERAL_PESCOCO_DIREITA',
  'ESCAPULO_UMERAL_DIREITO',
  'PALMAR_MAO_DIREITA',
  'EXTERNA_PUNHO_DIREITO',
  'EXTERNA_TERCO_INFERIOR_ANTEBRACO_DIREITO',
  'EXTERNA_TERCO_MEDIO_ANTEBRACO_DIREITO',
  'EXTERNA_TERCO_SUPERIOR_ANTEBRACO_DIREITO',
  'EXTERNA_COTOVELO_DIREITO',
  'EXTERNA_TERCO_INFERIOR_BRACO_DIREITO',
  'EXTERNA_TERCO_MEDIO_BRACO_DIREITO',
  'EXTERNA_TERCO_SUPERIOR_BRACO_DIREITO',
  'LATERAL_EXTERNA_PE_DIREITO',
  'MALEOLAR_DIREITA',
  'EXTERNA_TERCO_INFERIOR_PERNA_DIREITA',
  'EXTERNA_TERCO_SUPERIOR_PERNA_DIREITA',
  'EXTERNA_TERCO_MEDIO_PERNA_DIREITA',
  'EXTERNA_JOELHO_DIREITO',
  'EXTERNA_TERCO_INFERIOR_COXA_DIREITA',
  'EXTERNA_TERCO_MEDIO_COXA_DIREITA',
  'EXTERNA_TERCO_SUPERIOR_COXA_DIREITA',
  'QUADRIL_DIREITA',
  'GLUTEA_DIREITA',
  'OUTRO',
]

const TEXTO_ERRATA_DEFAULT = `
<p>
  Neste documento, em conformidade com os princípios de exatidão e integridade informativa, reconhece-se a necessidade de esclarecer e corrigir 
  informações contidas no relatório anterior.
</p>
<p style="text-align: justify;">&nbsp;</p>
<p>
  A errata a seguir aborda imprecisões ou equívocos identificados no relatório original, visando assegurar a correção dos registros, a precisão das informações e a validade do processo pericial.
</p>
<p style="text-align: justify;">&nbsp;</p>
<p>
  <b>Errata: </b>
</p>
<p style="text-align: justify;">&nbsp;</p>

<p><b>1. Página:</b>  [Indicar o número da página onde a correção será feita]</p>
<p><b>2. Item ou trecho original:</b> [Descrever o trecho ou item original que contém o erro]</p>
<p><b>3. Correção:</b>  [Especificar a correção a ser feita]</p>

<p style="text-align: justify;">&nbsp;</p>

<p>
  Ressalta-se o compromisso com a qualidade e ética no exercício da perícia criminal, dedicando-se à manutenção dos mais altos padrões profissionais nas investigações.
</p>
<p> 
  Esta errata será anexada ao relatório original, integrando-se ao registro pericial, a fim de garantir transparência e precisão nas conclusões e informações periciais.
</p>

`

const STATUS_CENTRAL_CUSTODIA = {
  PARA_ENTREGA: 'PARA_ENTREGA',
  EM_EXAME: 'EM_EXAME',
  PARA_ARMAZENAMENTO: 'PARA_ARMAZENAMENTO',
  PARA_DESCARTE: 'PARA_DESCARTE',
  PARA_ENTREGA_DESCARTE: 'PARA_ENTREGA_DESCARTE',
}

export default {
  LABEL_IDENTIFICADOR_ESPECIAL,
  PERMISSOES,
  LABEL_EXAMES_REALIZADOS,
  REGIOES_CORPO,
  TIPOS_EXAMES,
  TEXTO_ERRATA_DEFAULT,
  STATUS_CENTRAL_CUSTODIA,
}
